module.exports = __webpack_public_path__ + "dashboard/img/bullseye-arrow_dark.a1c13cfdda1a50e5b55c26e222c0b0be.svg";